import { render, staticRenderFns } from "./german_resources.vue?vue&type=template&id=15d4ffb1&scoped=true"
import script from "./german_resources.vue?vue&type=script&lang=js"
export * from "./german_resources.vue?vue&type=script&lang=js"
import style0 from "./german_resources.vue?vue&type=style&index=0&id=15d4ffb1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4ffb1",
  null
  
)

export default component.exports